import * as Yup from "yup";
/* eslint-disable import/prefer-default-export */
export const schema = Yup.object().shape({
  key: Yup.string().required(),
  quantity: Yup.number()
    .min(0, "La cantidad debe ser mayor a 0")
    .required("El campo es requerido"),
});
